var _defs, _rect, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew220({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.61,
    y: 4.95,
    width: 14.77,
    height: 7.43
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.25,
    y1: 8.66,
    x2: 13.75,
    y2: 8.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew220);
export default __webpack_public_path__ + "static/media/Symbolpack_New_220.c069e9afb69a80b7b227df063fd797c6.svg";
export { ForwardRef as ReactComponent };